// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"signin_loginForm__2YAdc","loginFormForgot":"signin_loginFormForgot__3_l5k","loginFormButton":"signin_loginFormButton__3DK1V"};